import { validations } from '@taxdown/papaya';

export const validPassword = password => validations.Password.validate(password);

export const validEmail = email => validations.Email.validate(email);

export const validRfc = rfc => validations.Rfc.validate(rfc);

export const maxLength = (value, max) => value.length < max;

export const minLength = (value, min) => value.length > min;

export const isNumber = value => !Number.isNaN(Number(value));

export const isGoogleDomain = email => {
  const googleDomains = [
    'gmail.com',
    'gmail.com.mx',
    'googlemail.com',
    'google.com',
    'gmial.com',
    'gamil.com',
    'gmeil.com',
    'gmil.com',
    'gmill.com',
    'gmaill.com',
    'gmal.com',
    'gmai.com',
    'g.mail.com.mx',
    'g.mail.com',
    'gmai.com',
    'gmali.com',
    'geamil.com',
    'gtmail.com',
    'gmsil.com',
  ];

  const domain = email.split('@')[1]?.toLowerCase();
  return googleDomains.includes(domain);
};
